export default "__VITE_ASSET__BFlElgz9__"